var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMyBusinessLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.419,
    height: 26.149,
    viewBox: "0 0 221.419 26.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "googleMyBusinessLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(-9.958 -128.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M20.342,137.486v2.8h6.688a5.929,5.929,0,0,1-1.525,3.526,6.844,6.844,0,0,1-5.164,2.047,7.439,7.439,0,0,1,0-14.878,7.112,7.112,0,0,1,5.039,2l1.967-1.967a9.659,9.659,0,0,0-7.006-2.844,10.238,10.238,0,1,0,0,20.473,9.384,9.384,0,0,0,7.143-2.866,9.26,9.26,0,0,0,2.422-6.541,8.98,8.98,0,0,0-.148-1.751Z",
    fill: "#346bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M42.837,147.306a4.014,4.014,0,1,1,3.731-4A3.822,3.822,0,0,1,42.837,147.306Zm0-10.612a6.609,6.609,0,1,0,6.631,6.608A6.512,6.512,0,0,0,42.837,136.694Z",
    transform: "translate(-4.569 -1.484)",
    fill: "#e12a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M78.2,147.306c-2,0-3.526-1.706-3.526-4,0-2.332,1.524-4,3.526-4,1.979,0,3.526,1.706,3.526,4.026A3.679,3.679,0,0,1,78.2,147.306Zm3.333-9.133h-.1a4.58,4.58,0,0,0-3.48-1.479,6.624,6.624,0,0,0,0,13.217,4.513,4.513,0,0,0,3.48-1.5h.1v.921c0,2.526-1.354,3.879-3.526,3.879a3.664,3.664,0,0,1-3.333-2.354L72.154,151.9a6.293,6.293,0,0,0,5.858,3.9c3.4,0,6.279-2,6.279-6.881V137.035H81.537Z",
    transform: "translate(-10.761 -1.484)",
    fill: "#346bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M60.74,147.306a4.014,4.014,0,1,1,3.731-4A3.822,3.822,0,0,1,60.74,147.306Zm0-10.612a6.609,6.609,0,1,0,6.631,6.608A6.512,6.512,0,0,0,60.74,136.694Z",
    transform: "translate(-7.685 -1.484)",
    fill: "#fdab00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2822",
    "data-name": "Rectangle 2822",
    width: 2.855,
    height: 19.985,
    transform: "translate(75.804 128.443)",
    fill: "#3d993d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M102.225,139.173a2.612,2.612,0,0,1,2.5,1.456L98.756,143.1A3.591,3.591,0,0,1,102.225,139.173Zm.2,8.133a3.364,3.364,0,0,1-3.208-2l8.837-3.651-.3-.751a6.136,6.136,0,0,0-5.653-4.209,6.28,6.28,0,0,0-6.233,6.608,6.461,6.461,0,0,0,6.552,6.609,6.591,6.591,0,0,0,5.5-2.924l-2.252-1.5A3.783,3.783,0,0,1,102.43,147.306Z",
    transform: "translate(-14.956 -1.484)",
    fill: "#e12a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M121.708,138.547l-.1-3h.1l5.605,9.834h1.351l5.605-9.834h.1l-.1,3v10.635h2.3V131.266h-2.3l-6.231,10.91h-.1l-6.231-10.91h-2.3v17.917h2.3Z",
    transform: "translate(-19.051 -0.539)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M151.948,138.113l-3.553,8.808h-.05l-3.653-8.808h-2.5l5.055,11.486-2.853,6.181h2.377l7.682-17.667Z",
    transform: "translate(-23.017 -1.731)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M172.834,141.1a2.987,2.987,0,0,1,2.2.876,2.809,2.809,0,0,1,.875,2.052,2.947,2.947,0,0,1-2.977,2.953H168.3V141.1Zm-.25-7.632a2.645,2.645,0,0,1,1.976.825,2.66,2.66,0,0,1-.025,3.829,2.784,2.784,0,0,1-2.052.826H168.3v-5.48Zm.25,15.714a5.389,5.389,0,0,0,3.828-1.451,4.719,4.719,0,0,0,1.6-3.653,4.153,4.153,0,0,0-.825-2.54,4.351,4.351,0,0,0-2.2-1.564v-.1a3.781,3.781,0,0,0,2.427-3.729,4.482,4.482,0,0,0-1.526-3.478,5.215,5.215,0,0,0-3.653-1.4H166v17.916Z",
    transform: "translate(-27.162 -0.539)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M194.253,138.113h-2.3v6.781a4.035,4.035,0,0,1-.926,2.665,2.877,2.877,0,0,1-2.3,1.113q-2.954,0-3.028-3v-7.557h-2.3v7.707a5.143,5.143,0,0,0,1.214,3.666,4.53,4.53,0,0,0,3.466,1.288,4.626,4.626,0,0,0,2.265-.6,4.1,4.1,0,0,0,1.614-1.5h.1v1.7h2.2Z",
    transform: "translate(-30.189 -1.731)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M205.346,143.208l-1.852-.475q-1.977-.451-1.976-1.5a1.3,1.3,0,0,1,.713-1.1,2.956,2.956,0,0,1,1.614-.451,3.574,3.574,0,0,1,1.764.438,2.586,2.586,0,0,1,1.139,1.214l2.052-.851a4.218,4.218,0,0,0-1.839-2.077,6.253,6.253,0,0,0-6.431.238,3.189,3.189,0,0,0-1.364,2.69q0,2.552,3.578,3.453l2.1.525q1.8.551,1.8,1.727a1.35,1.35,0,0,1-.738,1.126,3.33,3.33,0,0,1-1.839.476,3.192,3.192,0,0,1-1.889-.613,3.812,3.812,0,0,1-1.314-1.715l-2.052.875a5.308,5.308,0,0,0,2,2.541,5.6,5.6,0,0,0,3.253.963,5.535,5.535,0,0,0,3.528-1.1,3.324,3.324,0,0,0,1.4-2.7Q209,144.109,205.346,143.208Z",
    transform: "translate(-32.874 -1.646)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M213.56,136.879V149.14h2.3V136.879Zm2.3-5.38a1.632,1.632,0,1,0,.475,1.151A1.569,1.569,0,0,0,215.863,131.5Z",
    transform: "translate(-35.358 -0.497)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M220.083,150.29h2.3v-6.781a4.033,4.033,0,0,1,.926-2.665,2.878,2.878,0,0,1,2.3-1.113q2.952,0,3.028,3v7.556h2.3v-7.707a5.148,5.148,0,0,0-1.213-3.666,4.531,4.531,0,0,0-3.466-1.288,4.624,4.624,0,0,0-2.265.6,4.093,4.093,0,0,0-1.614,1.5h-.1v-1.7h-2.2Z",
    transform: "translate(-36.576 -1.646)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M239.422,140.53a3.337,3.337,0,0,1,2.24-.8,3.632,3.632,0,0,1,2.514.838,3.053,3.053,0,0,1,1.039,2.114h-7.032A3.827,3.827,0,0,1,239.422,140.53Zm5.755,9.284a6.115,6.115,0,0,0,2.29-2.427l-2.052-1a3.88,3.88,0,0,1-6.206,1.1,3.994,3.994,0,0,1-1.2-2.9h9.635l.025-.25a7.058,7.058,0,0,0-1.614-4.942,6.119,6.119,0,0,0-8.7.1,6.663,6.663,0,0,0-1.7,4.667,6.537,6.537,0,0,0,1.752,4.68,5.865,5.865,0,0,0,4.454,1.852A6.331,6.331,0,0,0,245.177,149.815Z",
    transform: "translate(-39.287 -1.646)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M258.457,143.208l-1.852-.475q-1.976-.451-1.976-1.5a1.3,1.3,0,0,1,.713-1.1,2.957,2.957,0,0,1,1.615-.451,3.578,3.578,0,0,1,1.764.438,2.588,2.588,0,0,1,1.138,1.214l2.052-.851a4.22,4.22,0,0,0-1.839-2.077,6.255,6.255,0,0,0-6.432.238,3.189,3.189,0,0,0-1.364,2.69q0,2.552,3.579,3.453l2.1.525q1.8.551,1.8,1.727a1.349,1.349,0,0,1-.738,1.126,3.33,3.33,0,0,1-1.839.476,3.192,3.192,0,0,1-1.889-.613,3.812,3.812,0,0,1-1.314-1.715l-2.052.875a5.31,5.31,0,0,0,2,2.541,5.6,5.6,0,0,0,3.253.963,5.535,5.535,0,0,0,3.528-1.1,3.324,3.324,0,0,0,1.4-2.7Q262.111,144.109,258.457,143.208Z",
    transform: "translate(-42.119 -1.646)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M272.242,143.208l-1.852-.475q-1.977-.451-1.977-1.5a1.3,1.3,0,0,1,.714-1.1,2.955,2.955,0,0,1,1.614-.451,3.574,3.574,0,0,1,1.764.438,2.588,2.588,0,0,1,1.138,1.214l2.052-.851a4.221,4.221,0,0,0-1.839-2.077,6.255,6.255,0,0,0-6.432.238,3.189,3.189,0,0,0-1.364,2.69q0,2.552,3.579,3.453l2.1.525q1.8.551,1.8,1.727a1.349,1.349,0,0,1-.738,1.126,3.329,3.329,0,0,1-1.839.476,3.192,3.192,0,0,1-1.89-.613,3.811,3.811,0,0,1-1.314-1.715l-2.052.875a5.31,5.31,0,0,0,2,2.541,5.6,5.6,0,0,0,3.253.963,5.534,5.534,0,0,0,3.528-1.1,3.324,3.324,0,0,0,1.4-2.7Q275.9,144.109,272.242,143.208Z",
    transform: "translate(-44.518 -1.646)",
    fill: "#7f7f7f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMyBusinessLogo);
export default __webpack_public_path__ + "static/media/googleMyBusinessLogo.83e51587.svg";
export { ForwardRef as ReactComponent };